if (!customElements.get('jane-carousel')) {
  customElements.define('jane-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.track = this.querySelector('[data-track]');
      this.controls = this.querySelector('[data-controls]');
      if (!this.track || !this.controls) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.previous = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      this.status = this.querySelector('[data-status]');
      this.progress = this.querySelector('[data-progress]');
      this.dots = this.querySelector('[data-dots]');
      if (this.dots) {
        this.dots.replaceChildren();
        [...this.track.children].forEach((item, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.setAttribute('aria-label', 'Go to slide ' + (index + 1));
          dot.setAttribute('aria-controls', this.track.id);
          dot.addEventListener('click', () => {
            const step = item.getBoundingClientRect().width + (parseFloat(getComputedStyle(this.track).gap) || 0);
            this.track.scrollTo({ left: index * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
          }, options);
          this.dots.append(dot);
        });
      }
      const move = direction => {
        const item = this.track.firstElementChild;
        if (!item) return;
        const step = item.getBoundingClientRect().width + (parseFloat(getComputedStyle(this.track).gap) || 0);
        const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({ left: direction * step, behavior: reduced ? 'instant' : 'smooth' });
      };
      this.previous.addEventListener('click', () => move(-1), options);
      this.next.addEventListener('click', () => move(1), options);
      this.track.addEventListener('scroll', () => {
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      }, { ...options, passive: true });
      this.resize = new ResizeObserver(() => this.update());
      this.resize.observe(this.track);
      this.update();
    }
    update() {
      if (!this.track) return;
      const maximum = this.track.scrollWidth - this.track.clientWidth;
      const scrollable = maximum > 4 && this.classList.contains('jane-mobile-carousel');
      this.dataset.scrollable = String(scrollable);
      this.controls.hidden = !scrollable;
      const children = [...this.track.children];
      const first = children[0];
      if (!first) return;
      const step = first.getBoundingClientRect().width + (parseFloat(getComputedStyle(this.track).gap) || 0);
      const position = Math.min(children.length - 1, Math.round(Math.max(0, this.track.scrollLeft) / step));
      const atEnd = this.track.scrollLeft >= maximum - 3;
      const active = atEnd && maximum > 4 ? children.length - 1 : position;
      this.previous.disabled = this.track.scrollLeft < 3;
      this.next.disabled = atEnd;
      if (this.dots) [...this.dots.children].forEach((dot, index) => {
        dot.setAttribute('aria-current', index === active ? 'true' : 'false');
      });
      const status = (active + 1) + ' / ' + children.length;
      if (this.status.textContent !== status) this.status.textContent = status;
      this.progress.style.transform = 'scaleX(' + ((active + 1) / children.length) + ')';
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.abort = null;
    }
  });
}
